import PropTypes from 'prop-types';

/**
 * Card component
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.hoverable - Enable hover effect
 * @param {React.ReactNode} props.children - Card content
 */
const Card = ({ className = '', hoverable = false, children, ...props }) => {
  const classes = `
    card
    ${hoverable ? 'cursor-pointer' : ''}
    ${className}
  `.trim();

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

Card.propTypes = {
  className: PropTypes.string,
  hoverable: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default Card;
